import { toast } from "sonner";
import { useStore } from "@/model/store";

/** A short confirmation with an Undo action: `POST /undo` undoes the last change you made. */
export function toastUndo(message: string, description?: string) {
	toast(message, {
		description,
		action: { label: "Undo", onClick: () => void useStore.getState().undo() },
	});
}
